import axios from 'axios';

export function generatePaymentCSV({id, ...data}) {
  return axios.post(`/payments/${id}/generate-tipalti-csv`, data);
}
